import {PermissionCollection} from "../../../collections/Permissions";

export class WeatherPermissionCollection extends PermissionCollection {
    canCreateNewLocation = this.generatePermissionFunction('app', 'location', 'create');
    canViewLocation = this.generatePermissionFunction('weatherl', null, 'view');
    canModifyLocation = this.generatePermissionFunction('weatherl', null, 'modify');
    canDeleteLocation = this.generatePermissionFunction('weatherl', null, 'delete');
}





// WEBPACK FOOTER //
// ./srv/public/js/apps/weather/collections/WeatherAppPermissions.ts